module.exports = "images/6ans.8f143626.png";